import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "../../../Features/User/UserSlice";
import {
  RiMailLine,
  RiLockPasswordLine,
  RiLoginCircleLine,
  RiUserAddLine,
  RiStore2Line,
  RiUserLine
} from "react-icons/ri";
import RegisterUserMedical from "../../RegisterUserMedical/RegisterUserMedical";
import "./LoginSignUp.css";

const LoginSignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("login");
  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const response = await axios.get(
          "https://api.swasthmitra.com/api/stores/get"
        );
        setStores(response.data);
      } catch (error) {
        console.error("Error fetching stores:", error.message);
      }
    };

    fetchStores();

    // Check for remembered credentials
    const rememberedEmail = localStorage.getItem("rememberedEmail");
    if (rememberedEmail) {
      setLoginData(prev => ({ ...prev, email: rememberedEmail }));
      setRememberMe(true);
    }
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setLoginError("");
  };

  const handleLoginChange = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setLoginError("");

    try {
      const response = await axios.post(
        "https://api.swasthmitra.com/api/usermedical/login",
        loginData
      );
      
      // Store email if remember me is checked
      if (rememberMe) {
        localStorage.setItem("rememberedEmail", loginData.email);
      } else {
        localStorage.removeItem("rememberedEmail");
      }

      localStorage.setItem("authToken", response.data.token);
      dispatch(setUser(response.data.user));
      navigate("/home");
    } catch (error) {
      setLoginError(error.response?.data?.message || "Login failed. Please try again.");
      console.error("Login Error:", error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);
  return (
    <div className="auth-page">
      <div className="auth-background">
        <div className="auth-overlay"></div>
      </div>
      
      <motion.div 
        className="auth-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="auth-header">
          <h2>Welcome to SwasthMitra</h2>
          <p>{activeTab === "login" ? "Sign in to continue" : "Create your account"}</p>
        </div>

        <div className="auth-tabs">
          <button
            className={`auth-tab ${activeTab === "login" ? "active" : ""}`}
            onClick={() => handleTabChange("login")}
          >
            <RiLoginCircleLine className="tab-icon" />
            <span>Login</span>
          </button>
          <button
            className={`auth-tab ${activeTab === "register" ? "active" : ""}`}
            onClick={() => handleTabChange("register")}
          >
            <RiUserAddLine className="tab-icon" />
            <span>Register</span>
          </button>
        </div>

        <AnimatePresence mode="wait">
          {activeTab === "login" ? (
            <motion.form
              key="login-form"
              className="auth-form"
              onSubmit={handleLoginSubmit}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              transition={{ duration: 0.3 }}
            >
              {loginError && (
                <div className="auth-error">
                  {loginError}
                </div>
              )}

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <div className="input-wrapper">
                  
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    value={loginData.email}
                    onChange={handleLoginChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <div className="input-wrapper">
                
                  <input
                    type="password"
                    id="password"
                    name="password"
                    placeholder="Enter your password"
                    value={loginData.password}
                    onChange={handleLoginChange}
                    required
                  />
                </div>
              </div>

              <div className="form-options">
                <label className="checkbox-container">
                  <input 
                    type="checkbox" 
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span className="checkmark"></span>
                  Remember me
                </label>
                <Link to="/resetPassword" className="forgot-password">
                  Forgot password?
                </Link>
              </div>

              <button 
                type="submit" 
                className="auth-button primary"
                disabled={loading}
              >
                {loading ? (
                  <span className="auth-spinner"></span>
                ) : (
                  <>
                    <RiLoginCircleLine className="button-icon" />
                    Sign In
                  </>
                )}
              </button>
             

              {/* <div className="auth-divider">
                <span>or continue with</span>
              </div> */}

            </motion.form>
          ) : (
            <motion.div
              key="register-form"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
            >
              <RegisterUserMedical />
            </motion.div>
          )}
        </AnimatePresence>

        {/* <div className="auth-footer">
          {activeTab === "login" ? (
            <p>Don't have an account? <button onClick={() => handleTabChange("register")}>Sign up</button></p>
          ) : (
            <p>Already have an account? <button onClick={() => handleTabChange("login")}>Sign in</button></p>
          )}
        </div> */}
      </motion.div>
    </div>
  );
};

export default LoginSignUp;